// import $ from 'jquery';
// import 'jquery-validation';
// import 'select2';
// import { isDevice } from './globalfunctions';
//
// window.$validator;
//
// function setValidation () {
//     // create validator instances
//     $('.modal__validator').each(function () {
//         window.$validator = $(this).validate({
//                 debug: false,
//                 focusInvalid: false,
//                 errorClass: 'invalid',
//                 errorElement: 'em',
//                 rules: {
//                     address_repeat_email: {
//                         equalTo: '#bill-email',
//                     },
//                     repeat_email: {
//                         equalTo: '#email',
//                     },
//                     txtemailrepeat: {
//                         equalTo: '#txtemail',
//                     },
//                     txtemailrepeat2: {
//                         equalTo: '#txtemail2',
//                     },
//                 },
//                 errorPlacement: function () {
//                     // empty Function removes Error Messages
//                 },
//                 invalidHandler: function (error, validator) {
//                     // Set 'no-scroll' Class at FORM Tag, to avoid scrolling to invalid Elements
//                     // should be used in Modal Boxes like "Ringmaß bestellen"
//                     if (isDevice === 'd' || !$(validator.currentElements.context).hasClass('no-scroll')) {
//                         if (validator.errorList.length >= 1 && !$(validator.currentElements.context).hasClass('no-scroll')) {
//                             const _notValidList = validator.errorList,
//                                 _notValidElements = [];
//
//                             // copy jquery elements into new array
//                             $(_notValidList).each(function (i, e) {
//                                 _notValidElements.push($(e.element)[0]);
//                             });
//
//                             // Scroll to first invalid Element
//                             $('html, body').animate({
//                                 scrollTop: $(_notValidList[0].element).offset().top - 100,
//                             }, 300);
//                         }
//                     }
//                 },
//                 highlight: function (element, errorClass) {
//                     switch ($(element)[0].type) {
//                         case 'select-one':
//                             var highlightElementId = $(element).data('validation-element-id');
//                             $('#' + highlightElementId).addClass(errorClass);
//                             $(element).next().find('.select2-selection--single').addClass(errorClass);
//                             break;
//                         case 'text':
//                             $(element).addClass(errorClass);
//                             break;
//                         case 'email':
//                             $(element).addClass(errorClass);
//                             break;
//                         case 'number':
//                             $(element).next('.input-number-error').removeClass('hide');
//                             $(element).addClass(errorClass);
//                             break;
//                         case 'tel':
//                             $(element).addClass(errorClass);
//                             break;
//                         case 'textarea':
//                             $(element).addClass(errorClass);
//                             break;
//                         case 'checkbox':
//                             $(element).offsetParent().addClass(errorClass);
//                             // check if checkbox has an Label/Text
//                             if ($(element).parent().next().hasClass('form__checkbox-text')) {
//                                 $(element).parent().next().addClass(errorClass);
//                             }
//                             break;
//                         case 'radio':
//                             var radioname = $(element)[0].name;
//                             $('input[type="radio"][name="' + radioname + '"]')
//                                 .next()
//                                 .addClass(errorClass + '-radio');
//
//                             $('.form__radio-text').addClass('required');
//                             break;
//                     }
//                 },
//                 unhighlight: function (element, errorClass) {
//                     switch ($(element)[0].type) {
//                         case 'select-one':
//                             $(element).next().find('.select2-selection--single').removeClass(errorClass);
//                             break;
//                         case 'text':
//                             $(element).removeClass(errorClass);
//                             break;
//                         case 'email':
//                             $(element).removeClass(errorClass);
//                             break;
//                         case 'number':
//                             $(element).next('.input-number-error').addClass('hide');
//                             $(element).removeClass(errorClass);
//                             break;
//                         case 'tel':
//                             $(element).removeClass(errorClass);
//                             break;
//                         case 'textarea':
//                             $(element).removeClass(errorClass);
//                             break;
//                         case 'checkbox':
//                             $(element).offsetParent().removeClass(errorClass);
//                             // check if checkbox has an Label/Text
//                             if ($(element).parent().next().hasClass('form__checkbox-text')) {
//                                 $(element).parent().next().removeClass(errorClass);
//                             }
//                             break;
//                         case 'radio':
//                             var radioname = $(element)[0].name;
//                             $('input[type="radio"][name="' + radioname + '"]')
//                                 .next()
//                                 .removeClass(errorClass + '-radio');
//
//                             $('.form__radio-text').removeClass('required');
//                             break;
//                     }
//                 },
//                 submitHandler: function (form) {
//                     // disable button to avoid multiple request
//                     $(form).find('input[type="submit"]').attr('disabled', true);
//                     form.submit();
//                 },
//             },
//         );
//     });
//
//     $.validator.methods.email = function (value, element) {
//         return this.optional(element) || /^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(value);
//     };
//
//     $('.input__email').rules('add', {
//         required: true,
//         email: true,
//     });
// }
//
// if ($('.modal__validator').length || $('#form__validator').length) {
//     setValidation();
// }
//
// /**
//  * Select2
//  */
// $('.country-select, .address-select, .date-select, .form__select').select2({
//     minimumResultsForSearch: -1,
//     placeholder: $(this).data('placeholder') ? '' : 'Auswählen',
// });
//
// // Part of Formvalidation for Select2 Dropdowns
// // If User selects a Value, this Dropdown will be Valid
// $('.form__select').on('select2:select', function (evt) {
//     $(evt.currentTarget).valid();
// });
